var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakaobank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x8B\xE1\x85\xB2\xE1\x86\xBC\xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB_SVG_\xE1\x84\x8F\xE1\x85\xA1\xE1\x84\x8F\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xA9\xE1\x84\x87\xE1\x85\xA2\xE1\x86\xBC\xE1\x84\x8F\xE1\x85\xB3 1",
    clipPath: "url(#clip0_1736_9905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z",
    fill: "#FFE300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.8956 12C16.4832 11.6136 16.9304 11.0479 17.171 10.3871C17.4116 9.72625 17.4326 9.00545 17.231 8.33171C17.0293 7.65797 16.6158 7.06722 16.0518 6.64717C15.4878 6.22711 14.8033 6.00016 14.1 6H8.62026C8.59549 5.99994 8.57094 6.00476 8.54803 6.01419C8.52512 6.02362 8.50429 6.03747 8.48673 6.05495C8.46916 6.07242 8.45522 6.09319 8.44568 6.11606C8.43615 6.13892 8.43121 6.16345 8.43115 6.18822V17.8104C8.43115 17.8609 8.45098 17.9093 8.48636 17.9452C8.52175 17.9811 8.56984 18.0017 8.62026 18.0024H14.1C14.8034 18.0024 15.4879 17.7756 16.0521 17.3556C16.6162 16.9356 17.0298 16.3448 17.2315 15.6711C17.4332 14.9973 17.4123 14.2764 17.1717 13.6155C16.9312 12.9546 16.4839 12.3889 15.8963 12.0024L15.8956 12ZM13.2067 14.7307H12.1769V9.26933H13.206L13.2067 14.7307Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_9905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaobank);
export default __webpack_public_path__ + "static/media/kakaobank.0fb506375358df02cfa4f6dd876027ec.svg";
export { ForwardRef as ReactComponent };